(() => {
  const body = document.body;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const respectReduced = body.dataset.respectReducedMotion !== 'false';
  const motionAllowed = !(respectReduced && reduced);

  if (body.dataset.smoothScroll === 'true' && motionAllowed) document.documentElement.classList.add('smooth-scroll-enabled');
  if (body.dataset.focusRing === 'true') body.classList.add('focus-ring-enabled');

  if (body.dataset.sectionReveal === 'true' && motionAllowed) {
    body.classList.add('reveal-enabled');
    const sections = document.querySelectorAll('[data-reveal-section]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      sections.forEach((section) => observer.observe(section));
    } else sections.forEach((section) => section.classList.add('is-revealed'));
  }

  const button = document.querySelector('[data-back-to-top]');
  if (button) {
    const offset = Number(button.dataset.offset || 500);
    const update = () => button.classList.toggle('is-visible', window.scrollY >= offset);
    window.addEventListener('scroll', update, { passive: true });
    update();
    button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: motionAllowed ? 'smooth' : 'auto' }));
  }
})();
